import React, {useEffect, useState} from 'react';
import Button from "../../../../../core/components/button";
import Typo from "../../../../../core/components/typo";
import {Alert, Divider, Spin} from "antd";
import {useNavigate, useParams} from "react-router-dom";
import RenderIf from "../../../../../core/components/render-if";
import QuizViewQuestion from "../../../../../core/components/quiz-view/components/question";
import QuizViewOption from "../../../../../core/components/quiz-view/components/option";
import handleError from "../../../../../core/helper/handelError";
import {useSendMissionRunnerReport} from "../../../api/missionRunner";
import {useGetExamDetail, useGetExamMyAnswerDetail, usePostSaveAnswers} from "../../../api/from";
import TimerExamComponent from "./TimerExamComponent";
import {isError, isNull} from "lodash/lang";
import handelApiSuccessMessage from "../../../../../core/helper/handelApiSuccessMessage";
import ExamReportCard from "./ExamReportCard";

export default function StepExam({content}) {
    const params = useParams();
    const id = params?.id;
    const stepId = params?.stepId;
    const runnerId = params?.runnerId;
    const paramContentId = params?.contentId;
    const formAnswerId = params?.formAnswerId;

    const [answers, setAnswers] = useState({})

    const [allowStartExam, setAllowStartExam] = useState(false)
    const [timeRemaining, setTimeRemaining] = useState(null);
    const [currentAnswer, setCurrentAnswer] = useState({})
    const [myAnswer, setMyAnswer] = useState({})


    const navigate = useNavigate();

    const mustBeGetExamData = !!formAnswerId && !!paramContentId && parseInt(paramContentId) === content?.id

    const {data: examData, isPending: isPendingExamData, isLoading: isLoadingExamData} =
        useGetExamDetail(content?.formId, formAnswerId, {}, {enabled: !!mustBeGetExamData});

    const {data: myAnswerData, isPending: isPendingMyAnswerData,isSuccess: isSuccessMyAnswerData,

        isError: isErrorMyAnswer} =
        useGetExamMyAnswerDetail(content?.formId, runnerId, {enabled: !formAnswerId});

    const {mutate: startExam, isLoading} = useSendMissionRunnerReport();
    const {mutate: saveAnswers, isPending: isPendingSaveAnswers} = usePostSaveAnswers();

    const showExamItem = !!paramContentId && parseInt(paramContentId) === content?.id && !!examData

    useEffect(() => {
        if (!formAnswerId && isSuccessMyAnswerData) {
            if (myAnswerData?.data?.id) {
                navigate(`/app/missions/${id}/${runnerId}/step/${stepId}/${content?.id}/${myAnswerData?.data?.id}`)
            }
        }

    }, [formAnswerId, isSuccessMyAnswerData]);


    useEffect(() => {
        if (examData?.data && examData?.data?.length > 0) {
            examData?.data.map((row, index) => {
                if (index === 0) {
                    if(row?.answer?.timeRemain)
                    {
                        setTimeRemaining(parseInt(row?.answer?.timeRemain ?? 0));
                    }
                    setCurrentAnswer(row?.answer)
                    if (row?.answer?.status === "running") {
                        setAllowStartExam(true);
                    }
                }

            });
        }
    }, [examData])

    useEffect(() => {
        if (isNull(timeRemaining) || timeRemaining === undefined) {
            return () => {
            }
        }
        if (timeRemaining <= 0) {
            onClickSaveAnswer();
            return () => {
            }
        }

        const timer = setInterval(() => {
            setTimeRemaining((prev) => Math.max(0, prev - 1));
        }, 1000);

        return () => clearInterval(timer);
    }, [timeRemaining]);


    const onClickStartExam = () => {
        startExam({
            runnerId: runnerId,
            stepId: stepId,
            contentId: content?.id
        }, {
            onSuccess: (res) => {
                navigate(`/app/missions/${id}/${runnerId}/step/${stepId}/${content?.id}/${res?.data?.formAnswerId}`)
            }, onError: (error) => {
                handleError(error)
            }
        })
    }

    const onClickSaveAnswer = () => {
        let myNewArrayAnswer = []
        let keys = Object.keys(myAnswer)
        keys.forEach((key) => {
            myNewArrayAnswer.push(myAnswer[key]);
        })


        saveAnswers({
            formId: content?.formId,
            formAnswerId: formAnswerId,
            data: {my_answers: myNewArrayAnswer},
        }, {
            onSuccess: (res) => {
                handelApiSuccessMessage(res)
                navigate(0)
            }, onError: (error) => {
                // handleError(error)
            }
        })
    }

    const handleClick = (itemId, optionId) => {

        let newMyAnswer = myAnswer
        newMyAnswer[itemId] = {form_answer_item_id: itemId, form_option_id: optionId}
        setMyAnswer(newMyAnswer)


        setAnswers(prev => ({
            ...prev,
            [itemId]: optionId
        }));

    };

    return (
        <>
            <div className={'items-center justify-center'}>
                <Divider size={"middle"}/>
                <div className={'flex flex-col gap-4 mx-auto items-center'}>
                    <Typo size="base" className="flex-1 items-center font-semibold">
                        {content?.title}
                    </Typo>
                    <RenderIf cond={!!content?.form?.description}>
                        <Typo size={"base"} type={'secondary'}>
                            {content?.form?.description}
                        </Typo>
                    </RenderIf>
                    <RenderIf cond={!currentAnswer?.status && !!content?.form?.descriptionBeforeStart}>
                        <Typo size={"base"} type={'secondary'}>
                            {content?.form?.descriptionBeforeStart}
                        </Typo>
                    </RenderIf>
                    <RenderIf cond={
                        (
                            currentAnswer?.status === 'done' ||
                            currentAnswer?.status === 'expired' ||
                            currentAnswer?.status === 'rejected'
                        ) && !!content?.form?.descriptionAfterEnd}>
                        <Typo size={"base"} type={'secondary'}>
                            {content?.form?.descriptionAfterEnd}
                        </Typo>
                    </RenderIf>

                    <RenderIf cond={!!content?.form?.duration && !showExamItem}>
                        <Alert
                            message={'توجه!'}
                            type={'info'} showIcon className={'ui-iransansX'} description={<>
                                                    مدت زمان پاسخگویی به آزمون از لحظه شروع
                            <span className={'mx-1'}>{content?.form?.duration}</span>
                            دقیقه می‌باشد
                            <br/>
                            در صورتی که آمادگی کامل را دارید دکمه شروع آزمون را بزنید
                        </>
                        } />

                    </RenderIf>
                    <RenderIf cond={!!content?.form?.duration && !!showExamItem && allowStartExam}>
                        <Typo size={"base"} type={'secondary'}>
                            <TimerExamComponent timeRemaining={timeRemaining}/>
                        </Typo>
                    </RenderIf>

                    <RenderIf cond={currentAnswer?.status === 'expired'}>
                        <Alert showIcon={true} type={'error'} className={'ui-iransansX'}
                               description={'متاسفانه شما نتوانستید در زمان تعیین شده آزمون را به پایان برسانید'}/>
                    </RenderIf>

                    <RenderIf cond={currentAnswer?.status === 'rejected'}>
                        <Alert showIcon={true} type={'error'} className={'ui-iransansX'}
                               description={'متاسفانه شما نتوانستید این آزمون را با موفقیت به پایان برسانید'}/>
                    </RenderIf>

                    <RenderIf cond={currentAnswer?.status === 'done'}>
                        <Alert showIcon={true} type={'success'} className={'ui-iransansX'}
                               message={'تبریک!'}
                               description={'شما این آزمون را با موفقیت به پایان رسانده اید'}/>
                    </RenderIf>

                    <RenderIf cond={currentAnswer?.status === 'running'}>
                        <Alert showIcon={true} type={'info'} className={'ui-iransansX'}
                               message={'آزمون شروع شد!'}
                               description={'لطفا با دقت به سوالات زیر پاسخ دهید'}/>
                    </RenderIf>

                    <RenderIf cond={!currentAnswer?.status}>
                        <RenderIf cond={isPendingExamData && formAnswerId} falsyElement={
                            <RenderIf cond={!paramContentId || parseInt(paramContentId) !== content?.id}>
                                <div className={'mt-5'}>
                                    <Button
                                        onClick={() => onClickStartExam()}
                                        type={'secondary'} size={'base'}>شروع آزمون</Button>
                                </div>
                            </RenderIf>
                        }>
                            <Spin spinning={true} size={'large'}/>
                        </RenderIf>
                    </RenderIf>

                    <RenderIf cond={currentAnswer?.status === 'done' || currentAnswer?.status === 'rejected'}>

                        <ExamReportCard answer={currentAnswer} />
                    </RenderIf>
                </div>
            </div>

            <div className={'grid grid-cols-1 gap-4'}>
                <RenderIf cond={showExamItem && allowStartExam}>
                    {examData?.data?.map((row, index) => {
                        return (
                            <>
                                <QuizViewQuestion key={row?.title + ' ' + index + ' ' + row?.id}
                                                  question={row?.item?.title}
                                                  index={index + 1}
                                                  description={row?.item?.description}
                                />
                                <div className="flex w-full flex-col gap-2 px-2 py-3 md:w-fit">
                                    {(row?.item?.options ?? []).map((option, iO) => (
                                        <QuizViewOption
                                            showTrueAnswer={false}
                                            key={iO + '-' + option?.id + option?.title}
                                            active={answers[row?.id] === option?.id}
                                            id={option?.id}
                                            onClick={() => handleClick(row?.id, option?.id)}
                                            option={option.title}
                                        />
                                    ))}
                                </div>
                            </>
                        )
                    })}

                    <div className={'max-w-2xl'}>
                        <Button onClick={onClickSaveAnswer} size={'sm'}>
                            ثبت پاسخ ها و پایان آزمون
                        </Button>
                    </div>
                </RenderIf>
            </div>
        </>
    );
}